module.exports = __webpack_public_path__ + "media/images/logo-ec529ea6e84f83c2f6ba9c7f28df9113.svg";